import React, { useEffect, useState } from 'react';
import { Button } from 'antd';
import dayjs from 'dayjs';
import {
  MobileFilterDrawer,
  StyledSelect,
  StyledRangePicker,
  StyledDatePicker
} from '../styled';

const { Option } = StyledSelect;

const FilterDrawer = ({ 
  visible, 
  onClose, 
  statusFilter, 
  setStatusFilter,
  riskFilter,
  setRiskFilter,
  locationFilter,
  setLocationFilter,
  dateRange,
  setDateRange,
  dobFilter,
  setDobFilter,
  dataSourceFilter,
  setDataSourceFilter,
  locations,
  onClear
}) => {
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' && window.matchMedia('(max-width: 767px)').matches
  );

  useEffect(() => {
    const mq = window.matchMedia('(max-width: 767px)');
    const handler = (e) => setIsMobile(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  return (
    <MobileFilterDrawer
      title="Filter Screening Data"
      placement={isMobile ? 'bottom' : 'right'}
      onClose={onClose}
      open={visible}
      width={isMobile ? undefined : 340}
      height={isMobile ? 'auto' : undefined}
      styles={{
        content: isMobile
          ? { borderTopLeftRadius: 16, borderTopRightRadius: 16 }
          : undefined
      }}
    >
      <div style={{ marginBottom: 16 }}>
        <label style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}>Status</label>
        <StyledSelect
          value={statusFilter}
          onChange={setStatusFilter}
          style={{ width: '100%' }}
          placeholder="Select Status"
        >
          <Option value="all">All Records</Option>
          <Option value="completed">Completed</Option>
          <Option value="archived">Archived</Option>
          <Option value="in_progress">In Progress</Option>
          <Option value="pending_review">Pending Review</Option>
        </StyledSelect>
      </div>

      <div style={{ marginBottom: 16 }}>
        <label style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}>Risk Level</label>
        <StyledSelect
          value={riskFilter}
          onChange={setRiskFilter}
          style={{ width: '100%' }}
          placeholder="Select Risk Level"
        >
          <Option value="all">All Risk Levels</Option>
          <Option value="minimal">Minimal Risk</Option>
          <Option value="low">Low Risk</Option>
          <Option value="medium">Medium Risk</Option>
          <Option value="high">High Risk</Option>
          <Option value="critical">Critical Risk</Option>
          <Option value="unknown">No Testing Data</Option>
        </StyledSelect>
      </div>

      <div style={{ marginBottom: 16 }}>
        <label style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}>Event</label>
        <StyledSelect
          value={locationFilter}
          onChange={setLocationFilter}
          style={{ width: '100%' }}
          placeholder="Select Event"
        >
          <Option value="all">All Events</Option>
          {locations.map(location => (
            <Option key={location} value={location}>
              {String(location)}
            </Option>
          ))}
        </StyledSelect>
      </div>

      <div style={{ marginBottom: 24 }}>
        <label style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}>Date Range</label>
        <StyledRangePicker 
          value={dateRange}
          onChange={setDateRange}
          placeholder={['Start Date', 'End Date']}
          style={{ width: '100%' }}
        />
      </div>

      <div style={{ marginBottom: 24 }}>
        <label style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}>Date of Birth</label>
        <StyledDatePicker
          value={dobFilter}
          onChange={setDobFilter}
          placeholder="Select birthday"
          format="MM/DD/YYYY"
          defaultPickerValue={dayjs('1985-01-01')}
          allowClear
          style={{ width: '100%' }}
        />
      </div>

      <div style={{ marginBottom: 24 }}>
        <label style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}>Data Source</label>
        <StyledSelect
          value={dataSourceFilter}
          onChange={setDataSourceFilter}
          style={{ width: '100%' }}
          placeholder="Select Source"
        >
          <Option value="all">All Sources</Option>
          <Option value="import">Imported</Option>
          <Option value="system">System</Option>
        </StyledSelect>
      </div>

      <div style={{ display: 'flex', gap: 8 }}>
        <Button 
          onClick={onClear}
          style={{ flex: 1 }}
        >
          Clear All
        </Button>
      </div>
    </MobileFilterDrawer>
  );
};

export default FilterDrawer;
